export const environment = {   
   apiUrl: 'http://ec2-35-180-114-89.eu-west-3.compute.amazonaws.com:3030',
   production: 'undefined'
};
